const data = [
    {
        srNo: 1,
        filedName: [
            // {
            //     name: "Aggregate Amount",
            //     type: 'number',
            //     readonly: false //true
            // },
            {
                name: "Date of Signing Approval Letter",
                type: 'date',
                readonly: false
            },
        ],
    },
    {
        srNo: 2,
        filedName: [
            {
                name: "Date of Intimation to Stock Exchange",
                type: 'date',
                readonly: false
            },
        ],
    },
    {
        srNo: 3,
        filedName: [
            {
                name: "Debenture Trustee Name",
                type: 'text',
                readonly: false
            },
            {
                name: "Debenture Trustee Address",
                type: 'text',
                readonly: false
            },
            {
                name: "Debenture Trustee Agreement Date",
                type: 'date',
                readonly: false
            },
            {
                name: "Debenture Trustee Consent Number",
                type: 'number',
                readonly: false
            },
            {
                name: "Debenture Trustee Consent Date",
                type: 'date',
                readonly: false
            },
        ],
    },
    {
        srNo: 4,
        filedName: [
            {
                name: "Credit Rating Agency Name_1",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating Agency Address_1",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating_1",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Agency Name_2",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating Agency Address_2",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating_2",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Agency Name_3",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating Agency Address_3",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating_3",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Agency Name_4",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating Agency Address_4",
                type: 'text',
                readonly: false
            },
            {
                name: "Credit Rating_4",
                type: 'number',
                readonly: false
            },
            {
                name: "Debenture Trustee Telephone Number",
                type: 'number',
                readonly: false
            },
            {
                name: "Debenture Trustee Website",
                type: 'text',
                readonly: false
            },
            {
                name: "Debenture Trustee Email ID",
                type: 'email',
                readonly: false
            },
            {
                name: "IM Date",
                type: 'date',
                readonly: false
            },
            {
                name: "Credit Rating Letter Date_1",
                type: 'date',
                readonly: false
            },
            {
                name: "Credit Rating Letter Amount_1",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Letter Date_2",
                type: 'date',
                readonly: false
            },
            {
                name: "Credit Rating Letter Amount_2",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Letter Date_3",
                type: 'date',
                readonly: false
            },
            {
                name: "Credit Rating Letter Amount_3",
                type: 'number',
                readonly: false
            },
            {
                name: "Credit Rating Letter Date_4",
                type: 'date',
                readonly: false
            },
            {
                name: "Credit Rating Letter Amount_4",
                type: 'number',
                readonly: false
            },
        ],
    },
    {
        srNo: 5,
        filedName: [
            {
                name: "Allotment Letter Date",
                type: 'date',
                readonly: false
            },
        ],
    },
    {
        srNo: "6 a",
        filedName: [
            {
                name: "Date of Master Creation Form CDSL / NSDL",
                type: 'date',
                readonly: false
            },
        ],
    },
    {
        srNo: 8,
        filedName: [
            {
                name: "Simple Mortgate Deed Number",
                type: 'number',
                readonly: false
            },
            {
                name: "Simple Mortgate Deed Date",
                type: 'date',
                readonly: false
            },
            {
                name: "Property Description",
                type: 'text',
                readonly: false
            },
        ],
    }, {
        srNo: 9,
        filedName: [
            {
                name: "Deed of Hypothecation Date",
                type: 'date',
                readonly: false
            },
        ],
    }, {
        srNo: 10,
        filedName: [
            {
                name: "Number of Debentures Issued",
                type: 'number',
                readonly: false
            },
            {
                name: "Debenture Trust Deed Date",
                type: 'date',
                readonly: false
            },
        ],
    }, {
        srNo: 18,
        filedName: [
            {
                name: "Date of Corporate Action (for redemption)",
                type: 'date',
                readonly: false
            },
        ],
    },
]



// filedName: [
//     { name: "ISIN NO" },
//     { name: "Scrip Code" },
//     { name: "Listing Date" },

//     { name: "Charge ID" },
//     { name: "Drawn Amount 1" },
// ]
// },

export default data;